export { default } from './UnscoredCategoryPageAboutSection'
